import React from 'react';
import styles from './PageTitle.module.css';

const PageTitle = ({ title, subtitle, icon, variant }) => {
  const bannerClass = variant === 'recording' 
    ? `${styles['title-banner']} ${styles.recording}`
    : styles['title-banner'];
    
  return (
    <div className={bannerClass}>
      {/* Top divider shape - upward chevron */}
      <div className={styles['banner-divider-top']}>
        <svg viewBox="0 0 1200 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <polygon points="0,60 600,0 1200,60" fill={variant === 'recording' ? '#22c55e' : '#0A3880'} />
        </svg>
      </div>
      
      <div className={styles['title-content']}>
        {icon && <div className={styles['title-icon']}>{icon}</div>}
        <h1 className={styles['title']}>{title}</h1>
        {subtitle && <p className={styles['subtitle']}>{subtitle}</p>}
      </div>
      
      {/* Bottom diagonal divider shape */}
      <div className={styles['banner-divider']}>
        <svg viewBox="0 0 1200 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <polygon points="0,0 1200,0 600,60" fill={variant === 'recording' ? '#22c55e' : '#0A3880'} />
        </svg>
      </div>
    </div>
  );
};

export default PageTitle;
